// 
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import React from 'react';

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const Home = () => {
  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <h1>Home</h1>
};

export default Home;